<template>
    <v-card color="#F5F2FB" flat class="rounded-0">
        <v-container class="py-8">
            <v-row>
                <v-col cols="12" lg="3">
                    <DashboardSidebar :buyedTotal="buyedTotal" :selfTotal="selfTotal"></DashboardSidebar>
                </v-col>
                <v-col cols="12" lg="9">
                    <!-- ==================== 设计师引导 Hero ==================== -->
                    <v-card class="designer-hero" flat>
                        <div class="hero-inner">
                            <div class="hero-text">
                                <p class="hero-eyebrow">
                                    <v-icon small class="mr-1">mdi-palette-outline</v-icon>
                                    {{ $t('模板设计师工作台') }}
                                </p>
                                <h2 class="hero-title">{{ $t('把你的设计变成收入') }}</h2>
                                <p class="hero-desc">{{ $t('你制作的模板可以发布到模版市场，其他卖家购买后你即可获得佣金收益。') }}</p>
                                <div class="hero-actions">
                                    <v-btn color="#fff" class="hero-btn-primary" rounded large elevation="2"
                                        @click="goPublish">
                                        <v-icon small class="mr-1" color="#7331FF">mdi-upload</v-icon>
                                        <span class="primary--text font-weight-bold">{{ $t('发布我的模板') }}</span>
                                    </v-btn>
                                    <v-btn outlined rounded large color="rgba(255,255,255,0.9)" to="/template-index">
                                        {{ $t('去模版市场看看') }}
                                    </v-btn>
                                </div>
                            </div>
                            <div class="hero-badge">
                                <v-icon size="56" color="rgba(255,255,255,0.9)">mdi-creation</v-icon>
                            </div>
                        </div>
                    </v-card>

                    <!-- ==================== 数据面板 ==================== -->
                    <div class="stat-grid mt-5">
                        <div class="stat-card">
                            <div class="stat-icon purple" style="background:#7331FF;box-shadow:0 4px 12px rgba(115,49,255,0.3);">
                                <v-icon color="#fff">mdi-palette-outline</v-icon>
                            </div>
                            <div class="stat-meta">
                                <p class="stat-num"><b>{{ selfTotal || 0 }}</b> {{ $t('个') }}</p>
                                <p class="stat-label">{{ $t('我的模板') }}</p>
                            </div>
                        </div>
                        <div class="stat-card">
                            <div class="stat-icon deep" style="background:#0F3460;box-shadow:0 4px 12px rgba(15,52,96,0.25);">
                                <v-icon color="#fff">mdi-shopping-outline</v-icon>
                            </div>
                            <div class="stat-meta">
                                <p class="stat-num"><b>{{ buyedTotal || 0 }}</b> {{ $t('个') }}</p>
                                <p class="stat-label">{{ $t('已购模板') }}</p>
                            </div>
                        </div>
                        <div class="stat-card stat-tip">
                            <v-icon color="#7331FF" class="mr-3">mdi-lightbulb-on-outline</v-icon>
                            <p class="mb-0">{{ $t('模板审核通过上架后，被其他卖家购买即可获得佣金收益') }}</p>
                        </div>
                    </div>

                    <!-- ==================== AI 设计模板引导 ==================== -->
                    <v-card flat class="ai-guide mt-5" @click="goAI">
                        <div class="ai-guide-left">
                            <v-icon size="30" color="#8B5CF6" class="mr-4">mdi-auto-fix</v-icon>
                            <div>
                                <p class="ai-guide-title">{{ $t('想快速出模板？试试 AI 设计') }}</p>
                                <p class="ai-guide-desc">{{ $t('一句话描述店铺风格，AI 自动生成专属模板，省时又省力') }}</p>
                            </div>
                        </div>
                        <v-btn color="#7331FF" dark rounded small class="ai-guide-btn" @click.stop="goAI">
                            <v-icon small class="mr-1">mdi-auto-fix</v-icon>
                            {{ $t('立即 AI 设计') }}
                        </v-btn>
                    </v-card>

                    <!-- ==================== 我的模板（设计师工作区） ==================== -->
                    <v-card flat class="template-panel pa-5 mt-5" id="self-workspace">
                        <div class="sec-head">
                            <div>
                                <h3 class="sec-title">{{ $t('我的模板') }}</h3>
                                <p class="sec-sub">{{ $t('发布你的设计，赚取佣金') }}</p>
                            </div>
                            <v-btn color="#7331FF" dark rounded @click="goPublish">
                                <v-icon small class="mr-1">mdi-plus</v-icon>
                                {{ $t('发布模板') }}
                            </v-btn>
                        </div>
                        <!-- 批量操作栏 -->
                        <div class="batch-bar">
                            <div class="batch-left">
                                <v-checkbox dense hide-details color="#7331FF" class="sel-check"
                                    :input-value="selectedIds.length === selflist.length && selflist.length > 0"
                                    @change="toggleAll" :label="$t('全选')"></v-checkbox>
                                <span class="batch-count" v-if="selectedIds.length > 0">
                                    {{ $t('已选') }} {{ selectedIds.length }} {{ $t('个') }}
                                </span>
                            </div>
                            <v-btn small outlined color="#FF5252" rounded class="batch-del-btn"
                                :disabled="selectedIds.length === 0" @click="batchDelShow = true">
                                <v-icon small class="mr-1">mdi-delete-sweep-outline</v-icon>
                                {{ $t('批量删除') }}
                            </v-btn>
                        </div>
                        <v-tabs background-color="#F6F8FC" center-active grow show-arrows slider-color="#7331FF"
                            color="#7331FF" class="self-tabs mt-2">
                            <v-tab v-for="(mitem, midx) in mobanlist" :key="midx"
                                class="text-subtitle-1" active-class="self-tab-active"
                                @click="tochangeSelf(mitem.val)">{{ $t(mitem.text) }}</v-tab>
                        </v-tabs>
                        <div class="mt-4">
                            <div class="self-grid" v-if="selflist.length > 0">
                                <div class="t-card" v-for="(sitem, sidx) in selflist" :key="sidx">
                                    <div class="t-cover">
                                        <div class="cover-box">
                                            <v-img :src="sitem.cover_img" alt="" class="cover-img" cover></v-img>
                                        </div>
                                        <div class="t-select">
                                            <v-checkbox dense hide-details color="#7331FF"
                                                :input-value="selectedIds.includes(sitem.custom_themes_id)"
                                                @change="toggleSelect(sitem.custom_themes_id)" @click.stop
                                                class="sel-check"></v-checkbox>
                                        </div>
                                        <div class="status-chip" :class="'status-' + sitem.themes_status">
                                            <span v-if="sitem.themes_status == 2">{{ $t('审核通过') }}</span>
                                            <span v-else-if="sitem.themes_status == 3">{{ $t('审核失败') }}</span>
                                            <span v-else-if="sitem.themes_status == 1">{{ $t('已发布') }}</span>
                                            <span v-else>{{ $t('未发布') }}</span>
                                        </div>
                                        <div class="t-hover" @click="$router.push('/template-detail-custom?custom_themes_id=' + sitem.custom_themes_id)">
                                            <v-btn color="#fff" class="hover-view-btn" rounded large elevation="3">
                                                <v-icon small class="mr-1">mdi-eye-outline</v-icon>
                                                {{ $t('查看') }}
                                            </v-btn>
                                        </div>
                                    </div>
                                    <div class="t-info">
                                        <span class="t-name">{{ sitem.custom_name || sitem.name }}</span>
                                        <span class="t-market" v-if="sitem.name">{{ sitem.name }}</span>
                                        <div class="t-actions">
                                            <v-btn v-if="sitem.themes_status == 0" color="#7331FF" dark rounded small class="ta-publish"
                                                @click="openDialog(sitem)">
                                                <v-icon x-small class="mr-1">mdi-upload</v-icon>
                                                <span v-if="sitem.is_sale == 0">{{ $t('发布') }}</span>
                                                <span v-else>{{ $t('更新') }}</span>
                                            </v-btn>
                                            <v-btn v-if="sitem.shop_id != $store.state.defaultShopid && sitem.themes_status != 0"
                                                outlined rounded small class="ta-apply"
                                                @click="touseCustom(sitem.custom_themes_id)">
                                                <v-icon x-small class="mr-1">mdi-store-outline</v-icon>
                                                {{ $t('应用') }}
                                            </v-btn>
                                            <v-btn icon small class="ta-del" @click="askDelSelfmoban(sitem.custom_themes_id)">
                                                <v-icon size="16" color="#FF5252">mdi-delete-outline</v-icon>
                                            </v-btn>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="pager-wrap" v-if="selfTotal > selfParam.page_number">
                                <v-pagination v-model="selfParam.current_page" :length="Math.ceil(selfTotal / selfParam.page_number)"
                                    color="#7331FF" circle="true" total-visible="7" @input="getSelfmoban()"></v-pagination>
                            </div>
                            <div class="empty-state" v-else>
                                <img src="@/assets/images/loading/wusousuo.png" alt="" class="empty-img">
                                <p class="grey--text">{{ $t('无结果') }}</p>
                            </div>
                        </div>
                    </v-card>

                    <!-- ==================== 已购买模版 ==================== -->
                    <v-card flat class="template-panel pa-5 mt-5">
                        <div class="sec-head">
                            <div>
                                <h3 class="sec-title">{{ $t('已购买模版') }}</h3>
                                <p class="sec-sub">{{ $t('当前店铺') }}：{{ DROPSHOPINFO.shop_name }}</p>
                            </div>
                        </div>
                        <div class="self-grid mt-2" v-if="mylist.length > 0">
                            <div class="t-card" v-for="(mitem, midx) in mylist" :key="midx">
                                <div class="t-cover">
                                    <div class="cover-box">
                                        <v-img :src="mitem.cover_img" alt="" class="cover-img" cover></v-img>
                                    </div>
                                    <span class="used-chip" v-if="mitem.is_exists == 1">{{ $t('当前店铺应用版本') }}：v{{ mitem.version }}</span>
                                    <div class="t-hover" @click="$router.push('/template-detail?themes_id=' + mitem.themes_id)">
                                        <v-btn color="#fff" class="hover-view-btn" rounded large elevation="3">
                                            <v-icon small class="mr-1">mdi-eye-outline</v-icon>
                                            {{ $t('查看') }}
                                        </v-btn>
                                    </div>
                                </div>
                                <div class="t-info">
                                    <span class="t-name">{{ mitem.name }}</span>
                                    <div class="t-actions">
                                        <v-btn v-if="mitem.is_exists == 0" outlined rounded small class="ta-apply"
                                            @click="touse(mitem.themes_id)">
                                            <v-icon x-small class="mr-1">mdi-store-outline</v-icon>
                                            {{ $t('应用') }}
                                        </v-btn>
                                        <v-btn v-if="mitem.is_new_version == 1" color="#7331FF" dark rounded small class="ta-update"
                                            @click="updateTheme(mitem)">
                                            <v-icon x-small class="mr-1">mdi-sync-outline</v-icon>
                                            {{ $t('更新') }}
                                        </v-btn>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="empty-state" v-else>
                            <img src="@/assets/images/template/no-buyed.png" alt="" class="empty-img">
                            <p class="grey--text">{{ $t('还未购买模版') }}</p>
                        </div>
                    </v-card>
                </v-col>
            </v-row>
        </v-container>
        <v-dialog v-model="releasedShow" width="820" persistent>
            <v-card flat v-if="releasedObj" class="release-card" style="border-radius:16px;overflow:hidden;">
                <div class="release-head">
                    <div class="release-head-left">
                        <span class="release-head-ic">
                            <v-icon color="#7331FF" size="24">mdi-creation</v-icon>
                        </span>
                        <span class="release-head-title">{{ $t('发布模版') }}</span>
                        <v-chip x-small color="#EFE8FF" class="ml-2 release-head-chip">{{ $t('提交后由平台审核') }}</v-chip>
                    </div>
                    <v-btn icon small @click="releasedShow = false">
                        <v-icon color="#B0B9C7">mdi-close</v-icon>
                    </v-btn>
                </div>
                <v-card class="overflow-y-auto" flat>
                    <v-card-text>
                        <v-card flat class="d-flex align-center pa-3 my-2" color="rgba(15,52,96,0.05)">
                            <v-icon color="#0F3460">mdi-information-outline</v-icon>
                            <p class="mb-0 ml-2" style="font-size:13px;line-height:1.6;color:#3D4757;">{{
                        $t('生成待发布模版，可在个人中心提交发布到模版市场，TaoifyShop会尽快审核，审核通过后将上架到模版市场，其他人购买后，可赚佣金。审核结果请在个人中心的自定义模版中查看，大概需要1~2个工作日。')
                    }}</p>
                        </v-card>
                        <!-- 第一步：选择要发布的未发布模板 -->
                        <div v-if="releasedStep == 'select'" class="step-select">
                            <p class="select-tip"><v-icon small class="mr-1">mdi-format-list-bulleted-type</v-icon>{{ $t('选择要发布的模板') }}</p>
                            <div class="select-list">
                                <div class="select-item" v-for="item in unpublishedList" :key="item.custom_themes_id"
                                    @click="openDialog(item)">
                                    <img :src="item.cover_img" class="select-cover" alt="">
                                    <div class="select-meta">
                                        <p class="select-name mb-0">{{ item.name || ('Template #' + item.custom_themes_id) }}</p>
                                        <p class="select-sub mb-0">{{ item.is_sale == 0 ? $t('新发布') : $t('发布新版本') }}</p>
                                    </div>
                                    <v-icon color="#C3CAD6">mdi-chevron-right</v-icon>
                                </div>
                                <div v-if="unpublishedList.length == 0" class="select-empty">
                                    <v-icon size="44" color="#D5DBE5" class="mb-2">mdi-inbox-outline</v-icon>
                                    <p class="mb-0">{{ $t('暂无未发布模板，请先在工作台制作模板') }}</p>
                                </div>
                            </div>
                        </div>

                        <template v-if="releasedStep == 'form'">
                        <p class="black--text pb-2 font-weight-bold form-section-title">{{ $t('作品信息') }}</p>

                        <div class="form-field">
                            <label class="form-label">{{ $t('名称') }}</label>
                            <v-text-field class="ipt-style" outlined dense v-model="releasedObj.name"
                                :placeholder="$t('模板名称')" hide-details></v-text-field>
                        </div>

                        <div class="form-field">
                            <label class="form-label">{{ $t('封面图') }}</label>
                            <div class="cover-upload-row">
                                <v-btn outlined rounded small @click="$refs.uploadCover.click()">
                                    <v-icon small class="mr-1">mdi-image-plus</v-icon>
                                    {{ $t('上传封面') }}
                                </v-btn>
                                <input type="file" ref="uploadCover" accept="image/*" class="d-none"
                                    @change="onFileChange" />
                                <img :src="releasedObj.cover_img" alt="" height="64" v-if="releasedObj.cover_img"
                                    class="release-cover-preview">
                            </div>
                        </div>

                        <div class="form-field">
                            <label class="form-label">{{ $t('模板描述') }}</label>
                            <v-textarea outlined dense v-model="releasedObj.des"
                                :placeholder="$t('模版亮点')" rows="2" hide-details></v-textarea>
                        </div>

                        <div class="form-field">
                            <label class="form-label">{{ $t('价格') }}</label>
                            <v-radio-group v-model="releasedObj.type" row dense class="pricing-group">
                                <v-radio :label="$t('免费')" value="1"></v-radio>
                                <v-radio :label="$t('付费')" value="2"></v-radio>
                            </v-radio-group>
                            <v-text-field v-if="releasedObj.type == 2" class="ipt-style" outlined dense
                                v-model="releasedObj.price" :prefix="DROPSHOPINFO.symbol" type="number"
                                :label="$t('价格')" hide-details></v-text-field>
                        </div>

                        <div class="form-field">
                            <label class="form-label">{{ $t('标签') }}</label>
                            <v-text-field class="ipt-style" outlined dense v-model="tagText"
                                @keyup.enter="addLocalpost" :placeholder="$t('按Enter键保存和添加更多')" hide-details></v-text-field>
                            <div class="tag-chip-row" v-if="releasedObj.themes_tag.length">
                                <v-chip small close v-for="(item, idx) in releasedObj.themes_tag"
                                    :key="idx" @click:close="delLocalpost(idx)" class="tag-chip">{{ item }}</v-chip>
                            </div>
                        </div>

                        <div class="form-field">
                            <label class="form-label">{{ $t('特点') }}</label>
                            <v-text-field class="ipt-style" outlined dense v-model="featureText"
                                @keyup.enter="addFeatureTag" :placeholder="$t('按Enter键添加特点')" hide-details></v-text-field>
                            <div class="tag-chip-row" v-if="releasedObj.features.length">
                                <v-chip small close v-for="(item, idx) in releasedObj.features"
                                    :key="idx" @click:close="delFeatureTag(idx)" class="tag-chip">{{ item }}</v-chip>
                            </div>
                        </div>
                        </template>
                    </v-card-text>
                </v-card>
                <v-divider></v-divider>
                <div class="release-foot">
                    <v-spacer></v-spacer>
                    <v-btn text rounded @click="releasedShow = false">{{ $t('关闭') }}</v-btn>
                    <v-btn v-if="releasedStep == 'form'" color="#7331FF" dark depressed rounded class="px-6" @click="postReleased">
                        <v-icon small class="mr-1">mdi-check</v-icon>
                        {{ $t('提交') }}
                    </v-btn>
                </div>
            </v-card>
        </v-dialog>
        <!-- 批量删除确认 -->
        <v-dialog v-model="batchDelShow" max-width="420" persistent>
            <v-card class="pa-2">
                <v-card-title class="text-h6">
                    <v-icon color="#FF5252" class="mr-2">mdi-delete-alert-outline</v-icon>
                    {{ $t('批量删除模板') }}
                </v-card-title>
                <v-card-text class="pt-0">
                    {{ $t('确定删除选中的') }} {{ selectedIds.length }} {{ $t('个模板吗？删除后不可恢复。') }}
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn text @click="batchDelShow = false">{{ $t('取消') }}</v-btn>
                    <v-btn color="#FF5252" dark depressed rounded @click="confirmBatchDel">
                        <v-icon small class="mr-1">mdi-delete</v-icon>
                        {{ $t('确认删除') }}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <!-- 单个删除确认 -->
        <v-dialog v-model="delConfirm.show" max-width="420" persistent>
            <v-card class="pa-2">
                <v-card-title class="text-h6">
                    <v-icon color="#FF5252" class="mr-2">mdi-delete-alert-outline</v-icon>
                    {{ $t('删除模板') }}
                </v-card-title>
                <v-card-text class="pt-0">
                    {{ $t('确定删除该模板吗？删除后不可恢复。') }}
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn text @click="delConfirm.show = false">{{ $t('取消') }}</v-btn>
                    <v-btn color="#FF5252" dark depressed rounded @click="confirmDelSelfmoban">
                        <v-icon small class="mr-1">mdi-delete</v-icon>
                        {{ $t('确认删除') }}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <!-- 已购模板删除确认 -->
        <v-dialog v-model="delBuyed.show" max-width="420" persistent>
            <v-card class="pa-2">
                <v-card-title class="text-h6">
                    <v-icon color="#FF5252" class="mr-2">mdi-delete-alert-outline</v-icon>
                    {{ $t('删除已购模板') }}
                </v-card-title>
                <v-card-text class="pt-0">
                    {{ $t('确定删除已购模板') }}「{{ delBuyed.name }}」{{ $t('吗？删除后将无法继续使用。') }}
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn text @click="delBuyed.show = false">{{ $t('取消') }}</v-btn>
                    <v-btn color="#FF5252" dark depressed rounded @click="confirmDelBuyed">
                        <v-icon small class="mr-1">mdi-delete</v-icon>
                        {{ $t('确认删除') }}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <!-- AI 设计引导弹窗 -->
        <v-dialog v-model="aiDialog" max-width="520" persistent>
            <div class="ai-dialog">
                <div class="ai-dialog-head">
                    <v-icon color="#FFD54F" size="34">mdi-auto-fix</v-icon>
                    <p class="ai-dialog-title">{{ $t('如何用 AI 设计模板') }}</p>
                </div>
                <div class="ai-steps">
                    <div class="ai-step">
                        <span class="ai-step-num">1</span>
                        <p class="ai-step-text">{{ $t('描述你的店铺类型和风格，如“欧美简约服饰店”') }}</p>
                    </div>
                    <div class="ai-step">
                        <span class="ai-step-num">2</span>
                        <p class="ai-step-text">{{ $t('AI 自动生成多套模板设计供你选择') }}</p>
                    </div>
                    <div class="ai-step">
                        <span class="ai-step-num">3</span>
                        <p class="ai-step-text">{{ $t('选中模板后一键启用，随时调整细节') }}</p>
                    </div>
                </div>
                <div class="ai-dialog-foot">
                    <v-btn color="#7331FF" dark rounded @click="goAIDesign">
                        {{ $t('立即去设计') }}
                    </v-btn>
                    <v-btn text rounded @click="aiDialog = false">{{ $t('我知道了') }}</v-btn>
                </div>
            </div>
        </v-dialog>

        <!-- 发布模板 -->
        <v-dialog v-model="selfObj.show" persistent width="450" attach="body">
            <v-card>
                <v-card-title class="text-h6">
                    <v-icon color="#faad14" class="mr-2">mdi-information-outline</v-icon>
                    {{ $t('发布模版') }}
                </v-card-title>
                <v-card-text>{{ $t('申请发布模版，TaoifyShop会尽快审核，请在个人中心查看结果。') }}</v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" text @click="selfObj.show = false">{{ $t('我知道了') }}</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-card>
</template>
<script>
import DashboardSidebar from '../../components/DashboardSidebar.vue'
export default {
    components: {
        DashboardSidebar
    },
    data() {
        return {
            mobanlist: [{ text: this.$t('全部自定义模版'), val: '-1' },
            { text: this.$t('待发布'), val: '0' },
            { text: this.$t('待审核'), val: '1' },
            { text: this.$t('审核通过'), val: '2' },
            { text: this.$t('审核未通过'), val: '3' }],
            mylist: [],
            postParam: {
                pay_status: 1,
                current_page: 1,
                page_number: 50
            },
            selfParam: {
                themes_status: '-1',
                current_page: 1,
                page_number: 20
            },
            selflist: [],//自定义模板
            selfObj: {
                show: false,
                themes_id: 0
            },
            buyedTotal: '',
            selfTotal: '',
            releasedObj: {
                custom_themes_id: '',
                type: '1',//1=免费，2=付费
                category: '',//类别
                name: "",//模板名称
                cover_img: "",//封面图
                price: "0",//价格
                des: "",//模板描述
                features: [],//特点
                themes_info: [{
                    decoration_module_id: '',
                    content: ''
                }],//模板预览链接
                edit_type: 3,//1=保存，2=另存为，3=上传到自定义模板
                custom_type: 2,//上传到自定义模板时，传此参数 ，1=更新，2=新增
                is_high_resolution: '1',//支持高分辨率
                support_browsers: '',//可兼容浏览器
                layout: '',//布局
                themes_tag: [],//模版标签ID
                version: 1,//版本号
            },// 发布模版
            releasedShow: false,// 发布模版弹窗
            releasedStep: 'form',// 发布弹窗步骤：select=选模板 / form=填信息
            layoutList: [this.$t('自适应'), this.$t('仅支持PC'), this.$t('仅支持H5')],//布局选项
            tagText: '',
            featureText: '',
            DROPSHOPINFO: JSON.parse(localStorage.getItem('DROPSHOPINFO')) || {},
            USERINFO: this.$store.state.USERINFO || {},
            selectedIds: [],//批量删除选中的模板
            selectAllFlag: false,
            batchDelShow: false,//批量删除确认弹窗
            delConfirm: { show: false, id: null },//单个删除确认
            delBuyed: { show: false, order_sn: '', name: '' },//已购模板删除确认
            aiDialog: false,//AI 设计引导弹窗
        }
    },
    computed: {
        // 未发布模板列表（发布弹窗第一步选择用）
        unpublishedList() {
            var list = this.selflist || [];
            // 当前就在"待发布"tab：selflist 本身就是待发布数据，直接用
            if (this.selfParam.themes_status == '0') return list;
            // 其他 tab：过滤出真正未发布的
            return list.filter(s => s.themes_status == 0 || s.themes_status == '0');
        }
    },
    mounted() {
        this.getMymoban();
        this.getSelfmoban(() => {
            const pid = this.$route.query.publish_id;
            if (pid && this.unpublishedList) {
                const target = this.unpublishedList.find(i => i.custom_themes_id == pid);
                if (target) this.openDialog(target);
            }
        });
    },
    methods: {
        getMymoban() {
            this.$api.template.order_list(this.postParam).then(res => {
                if (res.status && res.data.records) {
                    this.mylist = res.data.records;
                    this.buyedTotal = res.data.total;
                }
            })
        },
        //使用购买模版
        touse(id) {
            this.$api.template.use_themes({ themes_id: id }).then(res => {
                if (res.status) {
                    this.$Toast({ content: res.msg });
                    this.getMymoban()
                } else {
                    this.$Toast({ content: res.msg, type: 'error' });
                }
            })
        },
        //更新已购买模版版本号
        updateTheme(item) {
            this.$api.template.up_use_themes({ themes_order_id: item.themes_order_id }).then(res => {
                if (res.status) {
                    this.$Toast({ content: res.msg });
                    this.getMymoban()
                } else {
                    this.$Toast({ content: res.msg, type: 'error' });
                }
            })
        },
        //使用自定义模版
        touseCustom(id) {
            this.$api.template.use_custom_themes({ custom_themes_id: id }).then(res => {
                if (res.status) {
                    this.$Toast({ content: res.msg });
                    this.getMymoban()
                } else {
                    this.$Toast({ content: res.msg, type: 'error' });
                }
            })
        },

        //切换自定义模板状态
        tochangeSelf(type) {
            this.selfParam.themes_status = type;
            this.getSelfmoban();

        },
        getSelfmoban(cb) {
            this.$api.template.themes_list(this.selfParam).then(res => {
                if (res.status && res.data.records) {
                    this.selflist = res.data.records;
                    this.selfTotal = res.data.total;
                }
                if (typeof cb === 'function') cb();
            })
        },
        delSelfmoban(id) {
            this.$api.template.themes_del({ custom_themes_id: id }).then(res => {
                if (res.status) {
                    this.$Toast({ content: res.msg });
                    this.getSelfmoban();
                } else {
                    this.$Toast({ content: res.msg, type: 'error' });
                }
            })
        },
        // 单个删除：先弹确认
        askDelSelfmoban(id) {
            this.delConfirm.id = id;
            this.delConfirm.show = true;
        },
        confirmDelSelfmoban() {
            this.delConfirm.show = false;
            this.delSelfmoban(this.delConfirm.id);
        },
        // 已购模板删除
        askDelBuyed(item) {
            this.delBuyed.order_sn = item.order_sn;
            this.delBuyed.name = item.name;
            this.delBuyed.show = true;
        },
        confirmDelBuyed() {
            this.$api.template.del_order({ order_sn: this.delBuyed.order_sn }).then(res => {
                this.delBuyed.show = false;
                if (res.status) {
                    this.$Toast({ content: res.msg });
                    this.getMymoban();
                } else {
                    this.$Toast({ content: res.msg, type: 'error' });
                }
            })
        },

        //增加特性
        addFeature() {
            this.releasedObj.features.push('');
        },
        //删除特性
        delFeature(idx) {
            this.releasedObj.features.splice(idx, 1)
        },
        addFeatureTag() {
            if (this.featureText == "") return;
            this.releasedObj.features.push(this.featureText);
            this.featureText = "";
        },
        delFeatureTag(idx) {
            this.releasedObj.features.splice(idx, 1);
        },
        addLocalpost() {
            if (this.tagText == "") {
                return;
            }
            this.releasedObj.themes_tag.push(this.tagText);
            this.tagText = "";
        },
        //本地配送 删除一条邮编
        delLocalpost(idx) {
            this.releasedObj.themes_tag.splice(idx, 1);
        },

        //获取图片地址
        onFileChange(e) {
            this.webImageUrl = false;
            var files = e.target.files || e.dataTransfer.files;
            if (!files.length) return;

            var formData = new FormData();
            formData.append("file", files[0]);
            this.createImage(formData);
        },
        //生成图片路径
        createImage(file_) {
            this.$api.public.uploadimgs(file_).then(res => {
                if (res.status) {
                    this.$Toast({ content: res.msg, type: 'success' });
                    this.releasedObj.cover_img = res.data;
                }
            });
        },
        openDialog(item) {
            this.releasedObj.custom_themes_id = item.custom_themes_id;
            let item_ = JSON.parse(JSON.stringify(item));
            this.$api.template.themes_detail({ custom_themes_id: item.custom_themes_id }).then(res => {
                if (res.status) {
                    this.releasedObj = item_;
                    this.releasedObj.themes_info = res.data.content;
                    this.releasedObj.themes_tag = [];
                    if (res.data.themes_tag_info.length > 0) {
                        res.data.themes_tag_info.map(item => {
                            this.releasedObj.themes_tag.push(item.name)
                        })
                    }

                    this.releasedStep = 'form';
                    this.releasedShow = true;
                }
            })

        },
        //发布模版
        postReleased() {
            this.$api.template.themes_release(this.releasedObj).then(res => {
                this.selfObj.show = false;
                if (res.status) {
                    this.$Toast({ content: res.msg });
                    this.releasedShow = false;
                    this.releasedObj = {
                        custom_themes_id: '',
                        type: '1',//1=免费，2=付费
                        category: '',//类别
                        name: "",//模板名称
                        cover_img: "",//封面图
                        price: "0",//价格
                        des: "",//模板描述
                        features: [],//特点

                        themes_info: [{
                            decoration_module_id: '',
                            content: ''
                        }],//模板预览链接
                        edit_type: 3,//1=保存，2=另存为，3=上传到自定义模板
                        custom_type: 2,//上传到自定义模板时，传此参数 ，1=更新，2=新增
                        is_high_resolution: '1',//支持高分辨率
                        support_browsers: '',//可兼容浏览器
                        layout: '',//布局
                        themes_tag: [],//模版标签ID
                        version: "1",//版本号
                    }
                    this.selfObj.show = true;

                    // this.getSelfmoban();
                } else {
                    this.$Toast({ content: res.msg, type: 'error' });
                }

            })
        },
        // 发布模板：先弹"选择未发布模板"步骤
        goPublish() {
            this.releasedStep = 'select';
            this.releasedShow = true;
        },
        // ===================== 批量删除 =====================
        toggleSelect(id) {
            const i = this.selectedIds.indexOf(id);
            if (i > -1) {
                this.selectedIds.splice(i, 1);
            } else {
                this.selectedIds.push(id);
            }
        },
        toggleAll() {
            if (this.selectedIds.length === this.selflist.length) {
                this.selectedIds = [];
            } else {
                this.selectedIds = this.selflist.map(s => s.custom_themes_id);
            }
        },
        confirmBatchDel() {
            const ids = this.selectedIds.slice();
            const delOne = (idx) => {
                if (idx >= ids.length) {
                    this.$Toast({ content: this.$t('删除成功') });
                    this.selectedIds = [];
                    this.batchDelShow = false;
                    this.getSelfmoban();
                    return;
                }
                this.$api.template.themes_del({ custom_themes_id: ids[idx] }).then(r => {
                    if (!r.status) {
                        this.$Toast({ content: r.msg, type: 'error' });
                    }
                    delOne(idx + 1);
                });
            };
            delOne(0);
        },
        // ===================== AI 设计引导 =====================
        goAI() {
            this.aiDialog = true;
        },
        goAIDesign() {
            this.aiDialog = false;
            const origin = this.$store.state.locationOrigin || '';
            window.open(origin + '/manger_admin/template-design', '_blank');
        }
    }
}
</script>
<style lang="scss" scoped>
/* 白卡面板 */
.template-panel {
    background: #fff;
    border: 1px solid #EEF1F5;
    border-radius: 14px;
    box-shadow: 0 4px 16px rgba(15, 52, 96, 0.05);
}

/* ===================== 设计师引导 Hero ===================== */
.designer-hero {
    background: linear-gradient(135deg, #7331FF 0%, #9B5CFF 60%, #B07CFF 100%);
    border-radius: 16px;
    overflow: hidden;
    padding: 36px 40px;
    box-shadow: 0 12px 32px rgba(115, 49, 255, 0.22);

    .hero-inner {
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: 24px;
    }

    .hero-eyebrow {
        font-size: 13px;
        font-weight: 700;
        letter-spacing: 2px;
        color: rgba(255, 255, 255, 0.9);
        text-transform: uppercase;
        margin-bottom: 12px;
        display: flex;
        align-items: center;
    }

    .hero-title {
        font-size: 28px;
        font-weight: 700;
        color: #fff;
        margin-bottom: 10px;
    }

    .hero-desc {
        font-size: 14px;
        line-height: 1.7;
        color: rgba(255, 255, 255, 0.88);
        max-width: 560px;
        margin-bottom: 22px;
    }

    .hero-actions {
        display: flex;
        gap: 14px;
        flex-wrap: wrap;
    }

    .hero-btn-primary {
        text-transform: none;
        font-weight: 700;
    }

    .hero-badge {
        flex-shrink: 0;
        display: flex;
        align-items: center;
        justify-content: center;
    }
}

@media (max-width: 960px) {
    .designer-hero {
        padding: 26px 24px;

        .hero-title {
            font-size: 22px;
        }

        .hero-badge {
            display: none;
        }
    }
}

/* ===================== 数据面板 ===================== */
.stat-grid {
    display: grid;
    grid-template-columns: 180px 180px 1fr;
    gap: 20px;

    @media (max-width: 1200px) {
        grid-template-columns: repeat(2, 1fr);
    }

    @media (max-width: 700px) {
        grid-template-columns: 1fr 1fr;
    }
}

.stat-card {
    display: flex;
    align-items: center;
    gap: 14px;
    background: #fff;
    border: 1px solid #EEF1F5;
    border-radius: 14px;
    padding: 18px 20px;

    .stat-icon {
        width: 44px;
        height: 44px;
        border-radius: 12px;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-shrink: 0;

        &.purple {
            background: #7331FF;
            box-shadow: 0 4px 12px rgba(115, 49, 255, 0.3);
        }

        &.deep {
            background: #0F3460;
            box-shadow: 0 4px 12px rgba(15, 52, 96, 0.25);
        }
    }

    .stat-num {
        font-size: 13px;
        color: #8A96A8;
        margin-bottom: 2px;

        b {
            font-size: 22px;
            color: #0F3460;
        }
    }

    .stat-label {
        font-size: 13px;
        font-weight: 600;
        color: #242939;
        margin-bottom: 0;
    }

    &.stat-tip {
        background: rgba(115, 49, 255, 0.06);
        border-color: #EEE6FF;
        font-size: 13px;
        color: #3D4757;
        line-height: 1.6;
    }
}

/* ===================== AI 设计引导 ===================== */
.ai-guide {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 16px;
    background: linear-gradient(135deg, #F5F1FF 0%, #ECE4FB 100%);
    border: 1px solid #E3D9FF;
    border-radius: 14px;
    padding: 16px 20px;
    cursor: pointer;
    transition: box-shadow 0.2s, transform 0.2s;

    &:hover {
        box-shadow: 0 8px 24px rgba(115, 49, 255, 0.14);
        transform: translateY(-2px);
    }

    .ai-guide-left {
        display: flex;
        align-items: center;
        min-width: 0;
    }

    .ai-guide-title {
        font-size: 15px;
        font-weight: 700;
        color: #3D2B6B;
        margin-bottom: 2px;
    }

    .ai-guide-desc {
        font-size: 12px;
        color: #8A7BBF;
        margin-bottom: 0;
    }

    .ai-guide-btn {
        flex-shrink: 0;
        text-transform: none;
        font-weight: 700;
    }
}

/* ===================== 批量操作栏 ===================== */
.batch-bar {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    gap: 12px;
    background: #F6F8FC;
    border: 1px solid #EEF1F5;
    border-radius: 10px;
    padding: 6px 12px;
    margin-bottom: 12px;

    .batch-left {
        display: flex;
        align-items: center;
        gap: 8px;

        .sel-check {
            margin: 0;
            padding: 0;
        }

        .batch-count {
            font-size: 12px;
            color: #7331FF;
            font-weight: 600;
        }
    }

    .batch-del-btn {
        text-transform: none;
        font-weight: 600;
    }
}

/* ===================== 区块标题 ===================== */
.sec-head {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 16px;
    margin-bottom: 18px;

    .sec-title {
        font-size: 19px;
        font-weight: 700;
        color: #0F3460;
        margin-bottom: 4px;
    }

    .sec-sub {
        font-size: 12px;
        color: #9AA5B5;
        margin-bottom: 0;
    }

    .v-btn {
        text-transform: none;
    }
}

.self-tabs {
    border-radius: 10px;
    overflow: hidden;

    .v-tab {
        text-transform: none;
        letter-spacing: 0.2px;
    }

    .self-tab-active {
        background: #fff;
        color: #7331FF !important;
        font-weight: 600;
    }
}

/* ===================== 封面 9:16 ===================== */
.cover-box {
    position: relative;
    width: 100%;
    padding-top: 177.78%; /* 9:16 */
    overflow: hidden;

    .cover-img {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
    }
}

/* ===================== 模板卡片 ===================== */
.self-grid {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 20px;

    @media (max-width: 1200px) {
        grid-template-columns: repeat(3, 1fr);
    }

    @media (max-width: 960px) {
        grid-template-columns: repeat(2, 1fr);
    }

    @media (max-width: 480px) {
        grid-template-columns: 1fr;
    }
}

.t-card {
    cursor: pointer;
    border-radius: 14px;
    overflow: hidden;
    background: #fff;
    border: 1px solid #EEF1F5;
    transition: box-shadow 0.25s, transform 0.25s;

    &:hover {
        transform: translateY(-4px);
        box-shadow: 0 16px 36px rgba(15, 52, 96, 0.12);
    }
}

.t-cover {
    position: relative;
    margin: 8px;

    .cover-box {
        border-radius: 8px;
    }

    .status-chip {
        position: absolute;
        top: 12px;
        right: 12px;
        font-size: 11px;
        font-weight: 600;
        padding: 3px 10px;
        border-radius: 14px;
        z-index: 3;
        background: rgba(255, 255, 255, 0.94);
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);

        &.status-0 { color: #8A94A6; }
        &.status-1 { color: #7331FF; }
        &.status-2 { color: #09bb07; }
        &.status-3 { color: #FF2222; }
    }

    .t-select {
        position: absolute;
        top: 8px;
        left: 8px;
        z-index: 4;

        .sel-check {
            margin: 0;
            padding: 0;

            ::v-deep .v-input--selection-controls__input {
                width: 20px;
                height: 20px;
            }

            ::v-deep .v-input--selection-controls__ripple {
                display: none;
            }

            ::v-deep label::before {
                border-radius: 6px !important;
                border: 2px solid rgba(255, 255, 255, 0.9) !important;
                background: rgba(0, 0, 0, 0.15) !important;
            }

            ::v-deep label::after {
                border-radius: 6px !important;
            }
        }
    }

    .used-chip {
        position: absolute;
        top: 12px;
        left: 12px;
        font-size: 11px;
        font-weight: 600;
        padding: 3px 10px;
        border-radius: 14px;
        z-index: 3;
        background: #E1F6E0;
        color: #09bb07;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
    }

    .t-hover {
        position: absolute;
        inset: 0;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        background: rgba(15, 52, 96, 0.42);
        opacity: 0;
        transition: opacity 0.25s;
        z-index: 2;
        border-radius: 8px;

        .v-btn {
            white-space: normal;
            height: auto;
            min-height: 36px;
            max-width: 88%;
            padding-left: 14px;
            padding-right: 14px;
        }

        .v-btn__content {
            white-space: normal;
            text-align: center;
            line-height: 1.3;
        }

        &:hover {
            opacity: 1;
        }
    }

    /* hover 层：只显示一个居中"查看"按钮 */
    .hover-view-btn {
        text-transform: none;
        font-weight: 600;
        height: 36px;
    }

    &:hover .t-hover {
        opacity: 1;
    }
}

.t-info {
    display: flex;
    flex-direction: column;
    padding: 4px 14px 12px;

    .t-name {
        font-size: 14px;
        font-weight: 600;
        color: #242939;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        margin-bottom: 2px;
    }

    .t-market {
        font-size: 12px;
        color: #9AA5B5;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }

    .t-actions {
        display: flex;
        align-items: center;
        gap: 6px;
        margin-top: 10px;
        flex-wrap: nowrap;

        .v-btn {
            text-transform: none;
            height: 28px;
            min-height: 28px;
            font-size: 12px;
            font-weight: 600;
            padding-left: 10px;
            padding-right: 10px;
            white-space: nowrap;
        }

        .ta-publish {
            background: #7331FF;
        }

        .ta-apply {
            border-color: #E3D9FF;
            color: #7331FF;
        }

        .ta-update {
            background: #7331FF;
        }

        .ta-del {
            background: rgba(255, 82, 82, 0.08);
            width: 28px;
            height: 28px;
            min-width: 28px;

            &:hover {
                background: rgba(255, 82, 82, 0.16);
            }
        }
    }

    .t-version {
        margin-top: 4px;
    }
}

/* ===================== 空状态 ===================== */
.empty-state {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 40px 0;
    color: #9AA5B5;

    .empty-img {
        width: 100px;
        opacity: 0.6;
    }

    p {
        margin: 10px 0 0;
        font-size: 13px;
    }
}

.release-cover-preview {
    border-radius: 8px;
    border: 1px solid #EEF1F5;
}

/* ===================== AI 引导弹窗 ===================== */
.ai-dialog {
    background: #fff;
    border-radius: 16px;
    padding: 28px 32px 20px;

    .ai-dialog-head {
        display: flex;
        align-items: center;
        gap: 10px;
        margin-bottom: 20px;

        .ai-dialog-title {
            font-size: 19px;
            font-weight: 700;
            color: #0F3460;
            margin: 0;
        }
    }

    .ai-steps {
        display: flex;
        flex-direction: column;
        gap: 16px;
        margin-bottom: 24px;

        .ai-step {
            display: flex;
            align-items: flex-start;
            gap: 12px;

            .ai-step-num {
                width: 24px;
                height: 24px;
                border-radius: 50%;
                background: rgba(115, 49, 255, 0.10);
                color: #7331FF;
                font-size: 13px;
                font-weight: 700;
                display: flex;
                align-items: center;
                justify-content: center;
                flex-shrink: 0;
                margin-top: 1px;
            }

            .ai-step-text {
                font-size: 14px;
                color: #4A5568;
                line-height: 1.6;
                margin: 0;
            }
        }
    }

    .ai-dialog-foot {
        display: flex;
        justify-content: center;
        gap: 12px;
    }
}

/* ===== 发布模板弹窗 ===== */
.release-card {
    border-radius: 16px !important;
    overflow: hidden;

    .step-select {
        padding: 16px 4px 4px;

        .select-tip {
            display: flex;
            align-items: center;
            font-size: 14px;
            font-weight: 600;
            color: #2B3A55;
            margin-bottom: 12px;

            .v-icon { color: #7331FF; }
        }

        .select-list {
            max-height: 220px;
            overflow-y: auto;
            display: flex;
            flex-direction: column;
            gap: 8px;
            padding-top: 4px;
            padding-bottom: 4px;
        }

        .select-item {
            display: flex;
            align-items: center;
            gap: 12px;
            padding: 10px 12px;
            border: 1px solid #E9E2F0;
            border-radius: 12px;
            cursor: pointer;
            transition: all 0.18s;
            background: #fff;

            &:hover {
                border-color: #7331FF;
                box-shadow: 0 4px 14px rgba(115, 49, 255, 0.12);
                transform: translateY(-1px);
            }

            .select-cover {
                width: 52px;
                height: 78px;
                object-fit: cover;
                border-radius: 8px;
                flex-shrink: 0;
                background: #F5F2FB;
            }

            .select-meta {
                flex: 1;
                min-width: 0;

                .select-name {
                    font-size: 14px;
                    font-weight: 600;
                    color: #242939;
                    white-space: nowrap;
                    overflow: hidden;
                    text-overflow: ellipsis;
                }

                .select-sub {
                    font-size: 12px;
                    color: #9AA5B5;
                    margin-top: 2px;
                }
            }
        }

        .select-empty {
            text-align: center;
            padding: 32px 0;
            color: #9AA5B5;
            font-size: 13px;
        }
    }

    .release-head {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 16px 22px;
        background: #fff;
        border-bottom: 1px solid #F0F2F7;

        .release-head-left {
            display: flex;
            align-items: center;

            .release-head-ic {
                width: 38px;
                height: 38px;
                border-radius: 11px;
                background: #fff;
                display: inline-flex;
                align-items: center;
                justify-content: center;
                margin-right: 12px;
                box-shadow: 0 2px 8px rgba(115, 49, 255, 0.12);
            }

            .release-head-title {
                font-size: 18px;
                font-weight: 700;
                color: #0F3460;
            }

            .release-head-chip {
                color: #7331FF;
                font-weight: 600;
            }
        }
    }

    .pager-wrap {
        display: flex;
        justify-content: center;
        padding: 16px 0 4px;
    }

    .form-section-title {
        font-size: 15px;
        color: #1F2A3D;
        letter-spacing: 0.2px;
    }

    ::v-deep .release-card .v-card-text {
        padding: 16px 22px 12px;
    }

    ::v-deep .v-card-text::-webkit-scrollbar {
        width: 8px;
    }
    ::v-deep .v-card-text::-webkit-scrollbar-track {
        background: transparent;
    }
    ::v-deep .v-card-text::-webkit-scrollbar-thumb {
        background: #D5DBE5;
        border-radius: 8px;
    }
    ::v-deep .v-card-text::-webkit-scrollbar-thumb:hover {
        background: #B0BCCC;
    }

    .form-field {
        margin-bottom: 12px;

        .form-label {
            display: block;
            font-size: 13px;
            font-weight: 600;
            color: #3D4757;
            margin-bottom: 6px;
        }

        .cover-upload-row {
            display: flex;
            align-items: center;
            gap: 12px;
        }

        .tag-chip-row {
            display: flex;
            flex-wrap: wrap;
            gap: 6px;
            margin-top: 8px;

            .tag-chip {
                background: #F0EBFF;
                color: #7331FF;
            }
        }

        .feature-row {
            display: flex;
            align-items: center;
            gap: 6px;

            .v-input { flex: 1; }
        }
    }

    .release-foot {
        display: flex;
        align-items: center;
        padding: 14px 22px;
        background: #FAFBFF;
        border-top: 1px solid #EEF1F5;
    }
}
</style>
